const Cursor = {
    cursor: null,
    hoverItems: 'a, button, input[type=submit]',
    instances: [
        {
            type: 'flame',
            triggers: '',
        },
        {
            type: 'cart',
            triggers: '.add_to_cart_button',
        },
        {
            type: 'move',
            triggers: '.trigger-run2-cursor-move',
        },
        {
            type: 'eye',
            triggers: '.trigger-run2-cursor-eye',
        },
        {
            type: 'close',
            triggers: '',
        },
    ],
    triggers: '',
    hides: '',
    overrides: 'form',

    init: function() {
        this.cursor = document.getElementById('run2-cursor');
        this.setupEventListeners();
    },
    setCursor: function(type) {
        var self = this;
        self.cursor.classList.add('run2-cursor-'+type);
    },
    resetCursor: function() {
        var self = this;
        self.instances.forEach( (instance) => {
            self.cursor.classList.remove('run2-cursor-' + instance.type);
        });
    },


    hideCursor: function() {
        var self = this;
        if(self.cursor.classList.contains('run2-cursor-visible')) {
            self.cursor.classList.remove('run2-cursor-visible run2-cursor-hovering');
        }
    },
    overrideCursor: function() {
        var self = this;
        if(self.cursor.classList.contains('run2-cursor-override')) {
            self.cursor.classList.remove('run2-cursor-override');
        } else {
            self.cursor.classList.add('run2-cursor-override');
        }
    },
    showCursor: function() {
        var self = this;
        if(!self.cursor.classList.contains('run2-cursor-visible')) {
            self.cursor.classList.add('run2-cursor-visible');
        }
    },

    transformCursor: function(x,y) {
        var self = this;
        self.cursor.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0)';

    },

    addCSSClass: function() {
        
        var self = this;
        if(!self.cursor.classList.contains('run2-cursor-hovering')) {
            self.cursor.classList.add('run2-cursor-hovering');
            
        }
    },
    removeCSSClass: function() {
        var self = this;
        if(self.cursor.classList.contains('run2-cursor-hovering')) {
            self.cursor.classList.remove('run2-cursor-hovering');
        }
    },
    
    setupEventListeners: function() {
        var self = this;

        document.addEventListener('mousemove', () => {
            if(!self.cursor.classList.contains('run2-cursor-visible')) {
                self.cursor.classList.add('run2-cursor-visible');
            }
        }, { once: true });

        window.addEventListener('mousemove', (e) => {
            var x = e.clientX - self.cursor.offsetWidth / 2,
                y = e.clientY - self.cursor.offsetHeight / 2;
            
                requestAnimationFrame(() => {
                    self.transformCursor(x, y);
                })
        });


        document.querySelectorAll(self.hoverItems).forEach((el) => {
            el.addEventListener('mouseenter', () => {
                self.addCSSClass();
            });
            el.addEventListener('mouseleave', () => {
                self.removeCSSClass()
            });
        });

        self.instances.forEach((instance, i) => {
            if(instance.triggers.length) {
                self.triggers += instance.triggers;
                if (i + 1 < self.instances.length && self.instances[i+1].length) self.triggers += ', ';
            } else {
                return;
            }
            

            if(instance.triggers.length) {
                document.querySelectorAll(instance.triggers).forEach(function(el) {
                    el.addEventListener('mouseenter', () => {
                        self.setCursor(instance.type)
                    });
                    el.addEventListener('mouseleave', () => {
                        self.resetCursor()
                    });
                });
            }
        });

        if(self.triggers.length) {
            document.querySelectorAll(self.triggers).forEach((el) => {
                el.addEventListener('mouseleave', () => {
                    self.resetCursor()
                });
            });
        }

        if(self.overrides.length) {
            document.querySelectorAll(self.overrides).forEach((el) => {
                el.addEventListener('mouseenter mouseleave', () => {
                    self.overrideCursor()
                });
            });
        }

        if(self.hides.length) {
            document.querySelectorAll(self.hides).forEach((el) => {
                el.addEventListener('mousemove', () => {
                    self.hideCursor()
                });
                el.addEventListener('mouseleave', () => {
                    self.showCursor()
                });
            });
        }

        
  
    },
    
    
}

export { Cursor as default };


// WEBPACK FOOTER //
// ./scripts/components/cursor.js